import { render, staticRenderFns } from "./OlFolderTab.vue?vue&type=template&id=99088a4e&scoped=true&"
import script from "./OlFolderTab.vue?vue&type=script&lang=js&"
export * from "./OlFolderTab.vue?vue&type=script&lang=js&"
import style0 from "./OlFolderTab.vue?vue&type=style&index=0&id=99088a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99088a4e",
  null
  
)

export default component.exports